import Dot from "@assets/svg/Dot";
import Info from "@assets/svg/MyDeliveries/Info";
import CustomText from "@components/CustomText";
import Cross from "@assets/svg/CrossRed";
import React from "react";
import { StyleSheet, View, TouchableNativeFeedback } from "react-native";

const InfoLines = ({ info, state = null, onPress = () => {} }) => {
  const shouldShow = () => {
    if (state === "PRESS_CUT") {
      return false;
    }
    return true;
  };

  return shouldShow() ? (
    <View style={styles.container}>
      <View style={styles.infoRow}>
        <View style={styles.heading}>
          <View style={styles.iconContainer}>
            <Info style={styles.infoIcon} color="rgba(255, 122, 0, 1)" />
          </View>
          <CustomText variant="body_text_2" style={styles.infoText}>
            {info?.title}
          </CustomText>
        </View>
        {state === "IN_SCREEN" ? (
          <TouchableNativeFeedback testID="cross" onPress={() => onPress()}>
            <Cross
              width={22}
              height={22}
              bgColor="rgba(0,0,0,0.1)"
              color="black"
            />
          </TouchableNativeFeedback>
        ) : null}
      </View>
      {info?.list &&
        Array.isArray(info.list) &&
        info.list.map((i) => (
          <View style={styles.listRow}>
            <Dot fill="rgba(0, 0, 0, 1)" />
            <CustomText variant="body_text_4" style={styles.listItemText}>
              {i}
            </CustomText>
          </View>
        ))}
    </View>
  ) : null;
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 10,
    backgroundColor: "#FFF4E9",
    marginHorizontal: 8,
    marginBottom: 8,
    padding: 12,
  },
  infoRow: {
    flexDirection: "row",
    marginBottom: 7,
    justifyContent: "space-between",
  },
  heading: {
    flexDirection: "row",
  },
  infoIcon: {
    height: 20,
    width: 20,
  },
  infoText: {
    color: "rgba(0, 0, 0, 1)",
    marginLeft: 8,
  },
  listRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  listItemText: {
    color: "rgba(0, 0, 0, 0.86)",
    lineHeight: 22,
    marginLeft: 8,
  },
  iconContainer: { marginTop: 3 },
});

export default InfoLines;
